module.exports = __webpack_public_path__ + "img/b2b.c6cc60db.svg";